import { action, observable } from 'mobx';

/**
 * I-2092: whether the Sign out dialog is open. Every Sign out in the shell asks for it
 * (`requestSignOut`), and `Layout` draws it once, so the sidebar, the phone's menu and the profile page
 * cannot come to ask different things before ending the session.
 */
export const signOutPrompt = observable({ open: false });

export const requestSignOut = action((): void => {
  signOutPrompt.open = true;
});

export const dismissSignOut = action((): void => {
  signOutPrompt.open = false;
});
